import {
	ApplicationService,
	GamedayApiService,
	SeasonService
} from "@prestosports/prestostats-core/Services";
import GamedayApiClient from "../../services/gameday-api-client";
import {
	GET_CURRENT_SEASON,
	GET_CURRENT_SEASON_COMPLETE,
	GET_SEASONS,
	GET_SEASONS_COMPLETE,
	INIT_SEASON_DATA,
	INIT_SEASON_DATA_COMPLETE,
	RESET_CURRENT_SEASON,
	RESTORE_DEFAULT_GAME_CONFIGURATION,
	RESTORE_DEFAULT_GAME_CONFIGURATION_COMPLETE,
	SAVE_DEFAULT_GAME_CONFIGURATION,
	SAVE_DEFAULT_GAME_CONFIGURATION_COMPLETE,
	SET_CURRENT_SEASON,
	SET_CURRENT_SEASON_COMPLETE,
	SET_RULE_SET_ID_COMPLETE,
	SET_SEASON_CONFIGURATION,
	SET_SEASON_CONFIGURATION_COMPLETE
} from "./constants";
import { clearEvents } from "../events/actions";
import Alert from "../../util/alert";
import { GENERIC_SAVED_MSG } from "../../contstants/successes";
import { GENERIC_ERROR_MSG } from "../../contstants/errors";

GamedayApiService.setGamedayApiClient(GamedayApiClient);

const mapSeason = (season) => {
	return season?.toJSON();
};

export const setSeasonConfiguration = async (seasonId, dispatch) => {
	dispatch({
		type: SET_SEASON_CONFIGURATION
	});

	let payload = {
		defaultGameConfiguration: {},
		customFormData: {},
		rulesetDefaults: null
	};

	if (seasonId) {
		const { gameConfiguration, customFormData, rulesetDefaults } =
			await SeasonService.getGameConfigurationOrDefault(seasonId);

		const currentSeason = mapSeason(await ApplicationService.getCurrentSeason());

		payload = {
			defaultGameConfiguration: gameConfiguration,
			customFormData,
			rulesetDefaults,
			currentSeason
		};
	}

	dispatch({
		type: SET_SEASON_CONFIGURATION_COMPLETE,
		payload
	});
};

export const initSeasonData = async (seasonId, pagingOptions, dispatch) => {
	dispatch({
		type: INIT_SEASON_DATA
	});

	await ApplicationService.setCurrentSeason(seasonId);

	clearEvents(dispatch);
	await setSeasonConfiguration(seasonId, dispatch);

	dispatch({
		type: INIT_SEASON_DATA_COMPLETE
	});
};

export const saveDefaultGameConfiguration = async (
	seasonId,
	gameConfig,
	dispatch
) => {
	try {
		dispatch({
			type: SAVE_DEFAULT_GAME_CONFIGURATION
		});

		const {
			gameConfiguration: defaultGameConfiguration,
			customFormData,
			rulesetDefaults
		} = await SeasonService.saveGameConfiguration(seasonId, gameConfig);

		Alert.success(GENERIC_SAVED_MSG);
		dispatch({
			type: SAVE_DEFAULT_GAME_CONFIGURATION_COMPLETE,
			payload: { defaultGameConfiguration, customFormData, rulesetDefaults }
		});
	} catch (error) {
		Alert.error(GENERIC_ERROR_MSG);
	}
};

export const restoreDefaultGameConfiguration = async (seasonId, dispatch) => {
	dispatch({
		type: RESTORE_DEFAULT_GAME_CONFIGURATION
	});

	const {
		gameConfiguration: defaultGameConfiguration,
		customFormData,
		rulesetDefaults
	} = await SeasonService.restoreDefaultGameConfiguration(seasonId);

	Alert.success("Season settings restored to defaults");
	dispatch({
		type: RESTORE_DEFAULT_GAME_CONFIGURATION_COMPLETE,
		payload: { defaultGameConfiguration, customFormData, rulesetDefaults }
	});
};

export const getSeasons = async (sportCodes, dispatch) => {
	dispatch({
		type: GET_SEASONS
	});

	// try {
	const seasons = await GamedayApiService.getSeasons(sportCodes);
	dispatch({
		type: GET_SEASONS_COMPLETE,
		payload: { seasons: seasons && seasons.map(mapSeason) }
	});
	// } catch (e) {
	// 	// do nothing
	// 	console.error(e);
	// }
};

export const setCurrentSeasonById = async (seasonId, dispatch) => {
	dispatch({
		type: SET_CURRENT_SEASON
	});

	const currentSeason = await ApplicationService.setCurrentSeasonByExternalId(
		seasonId
	);

	await setSeasonConfiguration(currentSeason?.id, dispatch);

	dispatch({
		type: SET_CURRENT_SEASON_COMPLETE
	});
};

export const getCurrentSeason = async (dispatch) => {
	dispatch({
		type: GET_CURRENT_SEASON
	});

	const currentSeason = await ApplicationService.getCurrentSeason();

	dispatch({
		type: GET_CURRENT_SEASON_COMPLETE,
		payload: { currentSeason }
	});
};

export const resetCurrentSeason = (dispatch) => {
	dispatch({
		type: RESET_CURRENT_SEASON,
		payload: { currentSeason: null }
	});
};

export const setRuleSetId = async (season, ruleSetId, dispatch) => {
	// applyRuleSetChange, not restoreDefaultGameConfiguration (PSTATS-1380):
	// a rule set change keeps the settings the crew chose and takes the rest
	// from the new rule set, where "Restore defaults" deliberately wipes. It
	// also writes the id and the configuration together, so the season row
	// cannot end up naming one rule set while holding another's settings.
	await SeasonService.applyRuleSetChange(season.id, ruleSetId);
	const { gameConfiguration, customFormData, rulesetDefaults } =
		await SeasonService.getGameConfigurationOrDefault(season.id);

	dispatch({
		type: SET_RULE_SET_ID_COMPLETE,
		payload: {
			currentSeason: { ...season, ruleSetId },
			defaultGameConfiguration: gameConfiguration,
			customFormData,
			rulesetDefaults
		}
	});
};
